export const DATA_TZ_NAME_KEY = 'data-tz-name';
export const DATA_TZ_COUNTRY_CODE_KEY = 'data-tz-country-code';
export const DATA_FOR_TOOLTIP_VALUE = 'timezone-info';
// export const DATA_FOR_TOOLTIP_KEY = 'data-for';
// export const DATA_TIP_KEY = 'data-tip';
export const WORLD_MAP_SVG_ID = 'world-map';

export const OPAQUE_OPACITY_VALUE = 1;
export const SELECTED_TIME_ZONE_OPACITY_COEFFICIENT = 0.7;
export const NOT_MATCHED_TIME_ZONE_OPACITY_VALUE = 0.5;
